module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Flatten-4ec13a4bc786c8d3e41cc12f7e71064e.svg";